export class CountryModel {
    id!: string;
    name?: string;
    acronym?: string;

    constructor(name?: string, acronym?: string) {
        this.name = name;
        this.acronym = acronym;
    }
}